<div class="operating-hours-container">
  <div class="copy-hours-section">
    <div>
      <p class="title">Copy hours from another location</p>
      <p class="description">Easily apply existing hours from any of your locations.</p>
    </div>
    <div class="actions">
      <div class="dropdown">
        <mat-select
          class="form-select"
          [(ngModel)]="selectedLocation"
          (selectionChange)="onLocationChange($event)"
          placeholder="Select location"
        >
          <mat-option *ngFor="let location of locations" [value]="location">{{
            location.branch
          }}</mat-option>
        </mat-select>
      </div>
      <button
        class="btn btn-outlined btn-small apply-button"
        [ngClass]="{ disabled: !selectedLocation }"
        [disabled]="!selectedLocation"
        (click)="applyHours()"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>

  <div class="days-container">
    <div class="day-row" *ngFor="let day of days; trackBy: trackByIndex">
      <div class="day-name">{{ day.name }}</div>
      <div class="status-toggle">
        <label class="switch">
          <input
            type="checkbox"
            [checked]="day.isOpen"
            (change)="day.isOpen = !day.isOpen; onToggleDay(day)"
          />
          <span class="slider round"></span>
        </label>
        <span class="status-label">{{ day.isOpen ? 'Open' : 'Closed' }}</span>
      </div>
      <div class="time-inputs" [class.disabled]="!day.isOpen">
        <div class="dropdown">
          <mat-select
            class="form-select"
            [(ngModel)]="day.openTime"
            [disabled]="!day.isOpen"
            [placeholder]="day.isOpen ? 'Select time' : 'Closed'"
            (selectionChange)="onOpenTimeChange(day)"
          >
            <mat-option *ngFor="let time of times" [value]="time">{{ time }}</mat-option>
          </mat-select>
        </div>
        <div class="time-separator">-</div>
        <div class="dropdown">
          <mat-select
            class="form-select"
            [(ngModel)]="day.closeTime"
            [disabled]="!day.isOpen"
            [placeholder]="day.isOpen ? 'Select time' : 'Closed'"
            (selectionChange)="onTimeChange()"
          >
            <mat-option *ngFor="let time of getFilteredCloseTimes(day)" [value]="time">{{
              time
            }}</mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <!-- <button class="btn btn-secondary btn-medium" (click)="onCancel()">
        Cancel
      </button> -->
    <button
      class="btn btn-primary btn-medium save-button"
      [ngClass]="{ disabled: !isFormModified }"
      [disabled]="!isFormModified"
      (click)="onSave()"
    >
      Save
    </button>
  </div>
</div>
